import { convertStateForAreaCheckbox } from "./functions/convertStateForAreaCheckbox";
import { convertStateForCollapse } from "./functions/convertStateForCollapse";
import { convertStateForPrefectureCheckbox } from "./functions/convertStateForPrefectureCheckbox";

import type { Props } from "../../props";
import type { Reducer } from "react";

type State = Props["groupedPrefectures"];
type Layer = "area" | "prefecture";
type CheckboxAction = {
  code: string;
  layer: Layer;
  type: "checkbox";
};
type CollapseAction = {
  code: string;
  type: "collapse";
};
export type Action = CheckboxAction | CollapseAction;

export const prefecturesReducer: Reducer<State, Action> = (state, action) => {
  const { code, type } = action;

  if (type === "checkbox" && action.layer === "prefecture")
    return state.map(convertStateForPrefectureCheckbox(code));

  if (type === "checkbox" && action.layer === "area")
    return state.map(convertStateForAreaCheckbox(code));

  if (type === "collapse") return state.map(convertStateForCollapse(code));

  return state;
};
